import React, { useEffect, useState } from 'react';
import { ReactFormBuilder, ReactFormGenerator } from 'react-form-builder2';
import { toast } from 'react-toastify';
import { url } from '../constant.tsx';
import { useSearchParams } from 'react-router-dom';

const Editor = () => {
  const [formData, setFormData] = useState([]);
  const [isPreview, setIsPreview] = useState(false);
  const [answerData] = useState([]);
  const [restart, setRestart] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showNameModal, setShowNameModal] = useState(false);
  const [docName, setDocName] = useState('');
  const [urlParams, setUrlParams] = useSearchParams();

  useEffect(() => {
    const isEditMode = urlParams.get('type') === 'edit';
    const isTemplateName = !!urlParams.get('templateName');

    if (isEditMode) {
      (async () => {
        const response = await fetch(`${url}/Visa/GetStructure`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: urlParams.get('id') }),
        }).then((res) => res.json());
        if (!response?.hasErrors) {
          setFormData(JSON.parse(response.json));
          setRestart(true);
          setTimeout(() => {
            setRestart(false);
          });
        }
      })();
    }

    if (isTemplateName) {
      (async () => {
        const response = await fetch(`${url}/Visa/GetTemplate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: urlParams.get('templateName'),
            id: urlParams.get('id'),
          }),
        }).then((res) => res.json());
        if (!response?.hasErrors) {
          setFormData(JSON.parse(response.json));
          setRestart(true);
          setTimeout(() => {
            setRestart(false);
          });
        }
      })();
    }
  }, []);

  const handleChange = (data) => {
    setFormData(data.task_data);
  };

  const handleChangeName = (event) => {
    const value = event.target.value;

    const isValid = /^[A-Za-z0-9_-]*$/.test(value);

    if (isValid && value.length <= 20) {
      setDocName(value);
    }
  };

  const saveForm = (data) => {
    sessionStorage.setItem('answerData', JSON.stringify(data));
  };

  const saveBuilder = async () => {
    setIsLoading(true);
    const body = JSON.stringify({
      json: btoa(unescape(encodeURIComponent(JSON.stringify(formData)))),
      id: urlParams.get('id'),
    });

    if (urlParams.get('type') === 'new') {
      setUrlParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set('type', 'edit');
        return newParams;
      });
    }

    try {
      const response = await fetch(`${url}/Visa/SaveStructure`, {
        method: 'POST',
        body,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json());
      if (response?.success) {
        toast.success('Form saved successfully', {
          type: 'success',
          position: 'bottom-right',
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const saveAsTemplate = async () => {
    if (docName) {
      setIsLoading(true);
      const body = JSON.stringify({
        json: btoa(unescape(encodeURIComponent(JSON.stringify(formData)))),
        name: docName,
      });

      try {
        const response = await fetch(`${url}/Visa/SaveAsTemplate`, {
          method: 'POST',
          body,
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((res) => res.json());
        if (response?.success) {
          toast.success('Template saved successfully', {
            type: 'success',
            position: 'bottom-right',
          });
          setDocName('');
          setShowNameModal(false);
        } else if (response?.hasErrors) {
          toast.error(response.errorMessage, {
            type: 'error',
            position: 'bottom-right',
          });
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    } else {
      toast.error('Document Name is required', {
        type: 'error',
        position: 'bottom-right',
      });
    }
  };

  return (
    <div className="f-wrapper">
      <div className="row mb-10">
        <div className="flex-row col-md-9">
          <h1>Form Builder</h1>
          <div style={{ marginTop: 5, marginRight: -7.5 }}>
            <button
              className="btn btn-success"
              onClick={() => setIsPreview(true)}
            >
              Preview
            </button>
            <button
              className={
                'btn btn-primary ml-1' + (isLoading ? ' disabled' : '')
              }
              onClick={() => saveBuilder()}
              disabled={isLoading}
            >
              Save
            </button>
            <button
              className={
                'btn btn-primary ml-1' + (isLoading ? ' disabled' : '')
              }
              onClick={() => setShowNameModal(true)}
              disabled={isLoading}
            >
              Save as Template
            </button>
          </div>
        </div>
      </div>
      {!isPreview && !restart && (
        <ReactFormBuilder onPost={handleChange} data={formData} />
      )}
      {isPreview && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="rtl">
                <ReactFormGenerator
                  data={formData}
                  onSubmit={saveForm}
                  action_name="לשמור"
                  answer_data={answerData}
                  form_action=""
                  form_method=""
                />

                <button
                  type="button"
                  style={{ top: -41, position: 'relative', right: 86 }}
                  className="btn btn-danger"
                  data-dismiss="modal"
                  onClick={() => setIsPreview(false)}
                >
                  לסגור
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showNameModal && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="form-group">
                <label>
                  Template name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  value={docName}
                  onChange={handleChangeName}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  className="btn btn-danger mr-1"
                  data-dismiss="modal"
                  onClick={() => setShowNameModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  data-dismiss="modal"
                  onClick={saveAsTemplate}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Editor;
